var styles = {"closeIconAlign":"SearchBox-module_closeIconAlign__sPuIo","searchBoxWidth":"SearchBox-module_searchBoxWidth__4zXTd"};

export { styles as default };
